import React, { useState } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import dayjs from "dayjs";

import FormHelperText from "@mui/material/FormHelperText";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

function DateField(props) {
  const { filter, fieldName, handleFilterChange, value } = props;
  const [error, setError] = useState("");

  const handleDateChange = (dateObj, context) => {
    const date = dateObj
      ? moment(dateObj.$d).format("YYYY-MM-DD").toString()
      : null;

    if (!context.validationError)
      handleFilterChange({ target: { name: fieldName, value: date } });
  };
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          name={fieldName}
          label={filter.label}
          views={["year", "month", "day"]}
          onChange={handleDateChange}
          onError={(err) => setError(err)}
          value={value ? dayjs(value) : null}
          slotProps={{ textField: { variant: "standard" } }}
        />
      </LocalizationProvider>
      {error && (
        <FormHelperText error id="{fieldProps.key}-text" sx={{ margin: 0 }}>
          Invalid date.
        </FormHelperText>
      )}
    </>
  );
}

export default DateField;
DateField.propTypes = {
  filter: PropTypes.shape({
    label: PropTypes.string.isRequired,
    filterId: PropTypes.string.isRequired,
  }).isRequired,
  fieldName: PropTypes.string.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};
DateField.defaultProps = {
  value: null,
};
